import { FilterField } from '@totem/components/ui_components/reportSettings/types';

export const bouncedEmailsContainerConfiguration: FilterField[] = [
  {
    key: 'email',
    label: 'Email',
    sortField: '_id',
    filterField: '',
    multiple: false,
    values: [],
  },
  {
    key: 'status',
    label: 'Status',
    sortField: 'status',
    filterField: 'status',
    multiple: true,
    values: [],
  },
  {
    key: 'organization',
    label: 'Organization',
    sortField: '',
    filterField: 'contacts.organizationName',
    multiple: true,
    values: [],
  },
  {
    key: 'count',
    label: 'Bounces',
    sortField: 'count',
    filterField: '',
    multiple: false,
    values: [],
  },
  {
    key: 'createdAt',
    label: 'First Bounce',
    sortField: 'createdAt',
    filterField: '',
    multiple: false,
    values: [],
  },
  {
    key: 'updatedAt',
    label: 'Last Bounce',
    sortField: 'updatedAt',
    filterField: '',
    multiple: false,
    values: [],
  },
];
